<script>
export default {
  name: 'ListHeader',
  props: {
    /** [{ key, label }] - omit for a list with no tabs. */
    tabs: { type: Array, default: () => [] },
    activeTab: { type: [String, Number], default: null },
    /** Shown in place of the tabs on a list that has none. */
    title: { type: String, default: null },
  },
  emits: ['tab-change'],
};
</script>

<template>
  <div class="list-card__header">
    <h2 v-if="title && !tabs.length" class="list-card__title">{{ title }}</h2>

    <div v-else class="list-card__tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="list-card__tab"
        :class="{ 'list-card__tab--active': tab.key === activeTab }"
        :aria-pressed="tab.key === activeTab"
        @click="$emit('tab-change', tab.key)"
      >
        {{ tab.label }}
      </button>
    </div>

    <div class="list-card__actions">
      <slot name="actions" />
    </div>
  </div>
</template>
